import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  BookingCancelInput,
  BookingCreatePaymentMutationInput,
  BookingFormTypeUpdateInput,
  BookingMutationInput,
  RefundMutationInput,
  PrintBookingTiketInput,
} from './model';

export function useCreateBooking(
  options?: UseMutationOptions<ApiResult<any>, ApiError, BookingMutationInput>,
) {
  return useMutation<ApiResult<any>, ApiError, BookingMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'bookings',
        method: 'POST',
        body,
        // classType
      });
    },
    options,
  );
}

export function useUpdateBooking(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    BookingFormTypeUpdateInput
  >,
) {
  return useMutation<ApiResult<any>, ApiError, BookingFormTypeUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `bookings/${body.bookingId}`,
        method: 'PUT',
        body: body.body,
        // classType
      });
    },
    options,
  );
}
export function useRefund(
  options?: UseMutationOptions<ApiResult<any>, ApiError, RefundMutationInput>,
) {
  return useMutation<ApiResult<any>, ApiError, RefundMutationInput>(
    async function (body) {
      return MutationFetchFunction({
        url: 'bookings/refund',
        method: 'POST',
        body: body.body,
      });
    },
    options,
  );
}
export function useBookingCreatePayment(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    BookingCreatePaymentMutationInput
  >,
) {
  return useMutation<
    ApiResult<any>,
    ApiError,
    BookingCreatePaymentMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `bookings/${body.creditSettlementId}/create-payment`,
      method: 'POST',
      body: body.body,
      // classType
    });
  }, options);
}

export function useBookingChangePayment(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    BookingCreatePaymentMutationInput
  >,
) {
  return useMutation<
    ApiResult<any>,
    ApiError,
    BookingCreatePaymentMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `bookings/${body.creditSettlementId}/change-payment-method`,
      method: 'PATCH',
      body: body.body,
      // classType
    });
  }, options);
}

export function useBookingCancel(
  options?: UseMutationOptions<ApiResult<any>, ApiError, BookingCancelInput>,
) {
  return useMutation<ApiResult<any>, ApiError, BookingCancelInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `bookings/${body.bookingId}/cancel`,
        method: 'PATCH',
      });
    },
    options,
  );
}
export function usePrintBookingTicket(
  options?: UseMutationOptions<any, ApiError, PrintBookingTiketInput>,
): UseMutationResult<any, ApiError> {
  return useMutation<any, ApiError, PrintBookingTiketInput>(async function (
    body,
  ) {
    return await MutationFetchFunction({
      url: `bookings/${body.bookingId}/print-tickets`,
      method: 'POST',
    });
  },
  options);
}
